import type { ContactPipelineInput } from 'app/generated/gql/graphql'

export function contactPipelineInput(
  pipelines: { id: string; stage?: string | null; __typename?: string }[],
): ContactPipelineInput[] | undefined {
  const input: ContactPipelineInput[] = []
  for (const pipeline of pipelines) {
    if (!pipeline.id || !pipeline.stage) return undefined
    input.push({ id: pipeline.id, stage: pipeline.stage })
  }
  return input
}
